import { render, staticRenderFns } from "./Support.vue?vue&type=template&id=9310a19e&scoped=true&"
import script from "./Support.vue?vue&type=script&lang=ts&"
export * from "./Support.vue?vue&type=script&lang=ts&"
import style0 from "./Support.vue?vue&type=style&index=0&id=9310a19e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9310a19e",
  null
  
)

export default component.exports